import {SET_TAXES_FLAG} from "../types/flag";

const initState = {
  isTaxPageEnabled: false,
}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_TAXES_FLAG:
      return { ...state, isTaxPageEnabled: action.payload }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/flag.js